import { default as aboutlMYbllDX90Meta } from "/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue?macro=true";
import { default as eventsXkjtRdesOZMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93gamQGr7s3FMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45sampleyiYf1SpivZMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45products0DmV4qZiDIMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93e1oEcfaX3cMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as view0rwOmQFPLqMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as index7jWK2joLveMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93AZQ70cxmuZMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexWTJFRvCKrKMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93YTFWhAaun8Meta } from "/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as index5NiV8vGZiJMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsfAz4F3UBEHMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordings7gKHSy33d8Meta } from "/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewsYLaqR3V3QDMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93YmfbHt3WcTMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue?macro=true";
import { default as indexYYmR9rrTY7Meta } from "/tmp/build_8a9f1a71/pages/[studio_url]/buy/product/[product_id]/index.vue?macro=true";
import { default as confirmMVqrRJjPRcMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue?macro=true";
import { default as confirmHMMDQBhByNMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue?macro=true";
import { default as calendarsnvOTVPgC9Meta } from "/tmp/build_8a9f1a71/pages/[studio_url]/calendar.vue?macro=true";
import { default as chatYkwLXAxX5FMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/chat.vue?macro=true";
import { default as about50KU7ilBiRMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/community-groups/[group_id]/about.vue?macro=true";
import { default as feedOxIoVEKTtyMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/community-groups/[group_id]/feed.vue?macro=true";
import { default as membersPmQggrzVKTMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/community-groups/[group_id]/members.vue?macro=true";
import { default as _91group_id_93D95F3gjVzSMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/community-groups/[group_id].vue?macro=true";
import { default as community_45profile_45editpJgD4GagyAMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/community-profile-edit.vue?macro=true";
import { default as _91id_93GUHM9vAqbXMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/community-profile/[id].vue?macro=true";
import { default as community5I3eboqZkQMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/community.vue?macro=true";
import { default as _91uuid_93El6pPiqNlRMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/complete-registration/[uuid].vue?macro=true";
import { default as _91unique_id_93wicVIUpbNsMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/contracts/[unique_id].vue?macro=true";
import { default as dashboardLUjLdkoyjDMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/dashboard.vue?macro=true";
import { default as indexkFsYmcRuaZMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/event/details/[event_id]/index.vue?macro=true";
import { default as checkout5Wmj6mnW2AMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue?macro=true";
import { default as select_45productDLAHgz5yD4Meta } from "/tmp/build_8a9f1a71/pages/[studio_url]/event/details/[event_id]/select-product.vue?macro=true";
import { default as eventsY1i6h5kOHpMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/events.vue?macro=true";
import { default as _91uuid_93Zp3gW4XxebMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/gifts/[uuid].vue?macro=true";
import { default as index6WKGl0cWmuMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/gifts/index.vue?macro=true";
import { default as _91invitation_id_93FrEKbfqFEIMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/gifts/invitation/[invitation_id].vue?macro=true";
import { default as _91product_id_93hFAsXHEIOmMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/gifts/product/[product_id].vue?macro=true";
import { default as indexjxOEpBK09sMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/index.vue?macro=true";
import { default as _91invitation_unique_id_93AeADjrSpWSMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/invitation/[invitation_unique_id].vue?macro=true";
import { default as joinBUVMujuZjeMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/join.vue?macro=true";
import { default as loginzlsnftm6NmMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/login.vue?macro=true";
import { default as logouth7sKfXAxE9Meta } from "/tmp/build_8a9f1a71/pages/[studio_url]/logout.vue?macro=true";
import { default as _91meeting_type_slug_93tBDPe9XqHcMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/meet/[meeting_type_slug].vue?macro=true";
import { default as _91meeting_unique_id_93Rhh6ldbaDfMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/meet/[meeting_unique_id].vue?macro=true";
import { default as _91meeting_unique_id_93BPFo6SwMWNMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/meeting/[meeting_unique_id].vue?macro=true";
import { default as my_45favoritestmIyIzbG48Meta } from "/tmp/build_8a9f1a71/pages/[studio_url]/my-favorites.vue?macro=true";
import { default as my_45studiosjrNZ0XMqtPMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/my-studios.vue?macro=true";
import { default as optinBb1fE315KXMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/optin.vue?macro=true";
import { default as _91episode_id_93mMzwUQyVnjMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue?macro=true";
import { default as indexhuyYT1MaumMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/podcasts/[podcast_id]/index.vue?macro=true";
import { default as index4RaFBy7RMqMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/podcasts/index.vue?macro=true";
import { default as aboutI6XisP4OFiMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/about.vue?macro=true";
import { default as digital_45download_45contentdcLnt6TjeWMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/digital-download-content.vue?macro=true";
import { default as eventsVS1iBvUiiPMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93vfYE4pD4rhMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45sampletLGd4EkfS9Meta } from "/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45products4u4cAOnabBMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93ApbmzoMlQvMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewmxufo7A6QvMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexI8rYlFusBWMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93KyToUu84K6Meta } from "/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexNRHHo68UqTMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_938UbZMMKcpVMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexPEZjWP3NWEMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsQMffEmjoZlMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsITyKxOmkTrMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/recordings.vue?macro=true";
import { default as reviews4sUMKF9StpMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_931F4L8exNrXMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id].vue?macro=true";
import { default as indexVZie5H9FXiMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/product/index.vue?macro=true";
import { default as indexp5TuKKtYMLMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/profile/index.vue?macro=true";
import { default as purchasesAfAf88UDK3Meta } from "/tmp/build_8a9f1a71/pages/[studio_url]/profile/purchases.vue?macro=true";
import { default as redemptionsgHHNODBJgpMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/profile/redemptions.vue?macro=true";
import { default as _91quiz_id_93IRUQzwM6XvMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/quiz/[quiz_id].vue?macro=true";
import { default as _91token_93oZ1mkcip05Meta } from "/tmp/build_8a9f1a71/pages/[studio_url]/reset-password/[uid]/[token].vue?macro=true";
import { default as resetpAPPIalodPMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/reset.vue?macro=true";
import { default as shopo6tTwHz7SyMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/shop.vue?macro=true";
import { default as signupHnVTwDActzMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/signup.vue?macro=true";
import { default as liveXJTn2yIAyvMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/streaming/[event_id]/live.vue?macro=true";
import { default as tipsNjFE8hgoFMMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/tips.vue?macro=true";
import { default as _91uuid_93kCzCzYnYqRMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/waiver/[uuid].vue?macro=true";
import { default as compactkXQTjQ4JlFMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/widgets/calendars/compact.vue?macro=true";
import { default as full14Wqs82i8DMeta } from "/tmp/build_8a9f1a71/pages/[studio_url]/widgets/calendars/full.vue?macro=true";
export default [
  {
    name: _91product_id_93YmfbHt3WcTMeta?.name ?? "bundle-bundle_id-product-product_id",
    path: _91product_id_93YmfbHt3WcTMeta?.path ?? "/bundle/:bundle_id()/product/:product_id()",
    meta: _91product_id_93YmfbHt3WcTMeta || {},
    alias: _91product_id_93YmfbHt3WcTMeta?.alias || [],
    redirect: _91product_id_93YmfbHt3WcTMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutlMYbllDX90Meta?.name ?? "bundle-bundle_id-product-product_id-about",
    path: aboutlMYbllDX90Meta?.path ?? "about",
    meta: aboutlMYbllDX90Meta || {},
    alias: aboutlMYbllDX90Meta?.alias || [],
    redirect: aboutlMYbllDX90Meta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: eventsXkjtRdesOZMeta?.name ?? "bundle-bundle_id-product-product_id-events",
    path: eventsXkjtRdesOZMeta?.path ?? "events",
    meta: eventsXkjtRdesOZMeta || {},
    alias: eventsXkjtRdesOZMeta?.alias || [],
    redirect: eventsXkjtRdesOZMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93gamQGr7s3FMeta?.name ?? "bundle-bundle_id-product-product_id-free-media-media_id",
    path: _91media_id_93gamQGr7s3FMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93gamQGr7s3FMeta || {},
    alias: _91media_id_93gamQGr7s3FMeta?.alias || [],
    redirect: _91media_id_93gamQGr7s3FMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45sampleyiYf1SpivZMeta?.name ?? "bundle-bundle_id-product-product_id-free-sample",
    path: free_45sampleyiYf1SpivZMeta?.path ?? "free-sample",
    meta: free_45sampleyiYf1SpivZMeta || {},
    alias: free_45sampleyiYf1SpivZMeta?.alias || [],
    redirect: free_45sampleyiYf1SpivZMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45products0DmV4qZiDIMeta?.name ?? "bundle-bundle_id-product-product_id-included-products",
    path: included_45products0DmV4qZiDIMeta?.path ?? "included-products",
    meta: included_45products0DmV4qZiDIMeta || {},
    alias: included_45products0DmV4qZiDIMeta?.alias || [],
    redirect: included_45products0DmV4qZiDIMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93e1oEcfaX3cMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93e1oEcfaX3cMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93e1oEcfaX3cMeta || {},
    alias: _91media_id_93e1oEcfaX3cMeta?.alias || [],
    redirect: _91media_id_93e1oEcfaX3cMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: view0rwOmQFPLqMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-view",
    path: view0rwOmQFPLqMeta?.path ?? "lessons/:lesson_id()/view",
    meta: view0rwOmQFPLqMeta || {},
    alias: view0rwOmQFPLqMeta?.alias || [],
    redirect: view0rwOmQFPLqMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: index7jWK2joLveMeta?.name ?? "bundle-bundle_id-product-product_id-lessons",
    path: index7jWK2joLveMeta?.path ?? "lessons",
    meta: index7jWK2joLveMeta || {},
    alias: index7jWK2joLveMeta?.alias || [],
    redirect: index7jWK2joLveMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93AZQ70cxmuZMeta?.name ?? "bundle-bundle_id-product-product_id-media-media_id",
    path: _91media_id_93AZQ70cxmuZMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93AZQ70cxmuZMeta || {},
    alias: _91media_id_93AZQ70cxmuZMeta?.alias || [],
    redirect: _91media_id_93AZQ70cxmuZMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexWTJFRvCKrKMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id",
    path: indexWTJFRvCKrKMeta?.path ?? "playlists/:playlist_id()",
    meta: indexWTJFRvCKrKMeta || {},
    alias: indexWTJFRvCKrKMeta?.alias || [],
    redirect: indexWTJFRvCKrKMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93YTFWhAaun8Meta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93YTFWhAaun8Meta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93YTFWhAaun8Meta || {},
    alias: _91media_id_93YTFWhAaun8Meta?.alias || [],
    redirect: _91media_id_93YTFWhAaun8Meta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: index5NiV8vGZiJMeta?.name ?? "bundle-bundle_id-product-product_id-playlists",
    path: index5NiV8vGZiJMeta?.path ?? "playlists",
    meta: index5NiV8vGZiJMeta || {},
    alias: index5NiV8vGZiJMeta?.alias || [],
    redirect: index5NiV8vGZiJMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsfAz4F3UBEHMeta?.name ?? "bundle-bundle_id-product-product_id-private-sessions",
    path: private_45sessionsfAz4F3UBEHMeta?.path ?? "private-sessions",
    meta: private_45sessionsfAz4F3UBEHMeta || {},
    alias: private_45sessionsfAz4F3UBEHMeta?.alias || [],
    redirect: private_45sessionsfAz4F3UBEHMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordings7gKHSy33d8Meta?.name ?? "bundle-bundle_id-product-product_id-recordings",
    path: recordings7gKHSy33d8Meta?.path ?? "recordings",
    meta: recordings7gKHSy33d8Meta || {},
    alias: recordings7gKHSy33d8Meta?.alias || [],
    redirect: recordings7gKHSy33d8Meta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewsYLaqR3V3QDMeta?.name ?? "bundle-bundle_id-product-product_id-reviews",
    path: reviewsYLaqR3V3QDMeta?.path ?? "reviews",
    meta: reviewsYLaqR3V3QDMeta || {},
    alias: reviewsYLaqR3V3QDMeta?.alias || [],
    redirect: reviewsYLaqR3V3QDMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexYYmR9rrTY7Meta?.name ?? "buy-product-product_id",
    path: indexYYmR9rrTY7Meta?.path ?? "/buy/product/:product_id()",
    meta: indexYYmR9rrTY7Meta || {},
    alias: indexYYmR9rrTY7Meta?.alias || [],
    redirect: indexYYmR9rrTY7Meta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/buy/product/[product_id]/index.vue").then(m => m.default || m)
  },
  {
    name: confirmMVqrRJjPRcMeta?.name ?? "buy-product-product_id-paypal-confirm",
    path: confirmMVqrRJjPRcMeta?.path ?? "/buy/product/:product_id()/paypal/confirm",
    meta: confirmMVqrRJjPRcMeta || {},
    alias: confirmMVqrRJjPRcMeta?.alias || [],
    redirect: confirmMVqrRJjPRcMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue").then(m => m.default || m)
  },
  {
    name: confirmHMMDQBhByNMeta?.name ?? "buy-product-product_id-stripe-confirm",
    path: confirmHMMDQBhByNMeta?.path ?? "/buy/product/:product_id()/stripe/confirm",
    meta: confirmHMMDQBhByNMeta || {},
    alias: confirmHMMDQBhByNMeta?.alias || [],
    redirect: confirmHMMDQBhByNMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue").then(m => m.default || m)
  },
  {
    name: calendarsnvOTVPgC9Meta?.name ?? "calendar",
    path: calendarsnvOTVPgC9Meta?.path ?? "/calendar",
    meta: calendarsnvOTVPgC9Meta || {},
    alias: calendarsnvOTVPgC9Meta?.alias || [],
    redirect: calendarsnvOTVPgC9Meta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/calendar.vue").then(m => m.default || m)
  },
  {
    name: chatYkwLXAxX5FMeta?.name ?? "chat",
    path: chatYkwLXAxX5FMeta?.path ?? "/chat",
    meta: chatYkwLXAxX5FMeta || {},
    alias: chatYkwLXAxX5FMeta?.alias || [],
    redirect: chatYkwLXAxX5FMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/chat.vue").then(m => m.default || m)
  },
  {
    name: _91group_id_93D95F3gjVzSMeta?.name ?? "community-groups-group_id",
    path: _91group_id_93D95F3gjVzSMeta?.path ?? "/community-groups/:group_id()",
    meta: _91group_id_93D95F3gjVzSMeta || {},
    alias: _91group_id_93D95F3gjVzSMeta?.alias || [],
    redirect: _91group_id_93D95F3gjVzSMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/community-groups/[group_id].vue").then(m => m.default || m),
    children: [
  {
    name: about50KU7ilBiRMeta?.name ?? "community-groups-group_id-about",
    path: about50KU7ilBiRMeta?.path ?? "about",
    meta: about50KU7ilBiRMeta || {},
    alias: about50KU7ilBiRMeta?.alias || [],
    redirect: about50KU7ilBiRMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/community-groups/[group_id]/about.vue").then(m => m.default || m)
  },
  {
    name: feedOxIoVEKTtyMeta?.name ?? "community-groups-group_id-feed",
    path: feedOxIoVEKTtyMeta?.path ?? "feed",
    meta: feedOxIoVEKTtyMeta || {},
    alias: feedOxIoVEKTtyMeta?.alias || [],
    redirect: feedOxIoVEKTtyMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/community-groups/[group_id]/feed.vue").then(m => m.default || m)
  },
  {
    name: membersPmQggrzVKTMeta?.name ?? "community-groups-group_id-members",
    path: membersPmQggrzVKTMeta?.path ?? "members",
    meta: membersPmQggrzVKTMeta || {},
    alias: membersPmQggrzVKTMeta?.alias || [],
    redirect: membersPmQggrzVKTMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/community-groups/[group_id]/members.vue").then(m => m.default || m)
  }
]
  },
  {
    name: community_45profile_45editpJgD4GagyAMeta?.name ?? "community-profile-edit",
    path: community_45profile_45editpJgD4GagyAMeta?.path ?? "/community-profile-edit",
    meta: community_45profile_45editpJgD4GagyAMeta || {},
    alias: community_45profile_45editpJgD4GagyAMeta?.alias || [],
    redirect: community_45profile_45editpJgD4GagyAMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/community-profile-edit.vue").then(m => m.default || m)
  },
  {
    name: _91id_93GUHM9vAqbXMeta?.name ?? "community-profile-id",
    path: _91id_93GUHM9vAqbXMeta?.path ?? "/community-profile/:id()",
    meta: _91id_93GUHM9vAqbXMeta || {},
    alias: _91id_93GUHM9vAqbXMeta?.alias || [],
    redirect: _91id_93GUHM9vAqbXMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/community-profile/[id].vue").then(m => m.default || m)
  },
  {
    name: community5I3eboqZkQMeta?.name ?? "community",
    path: community5I3eboqZkQMeta?.path ?? "/community",
    meta: community5I3eboqZkQMeta || {},
    alias: community5I3eboqZkQMeta?.alias || [],
    redirect: community5I3eboqZkQMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/community.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93El6pPiqNlRMeta?.name ?? "complete-registration-uuid",
    path: _91uuid_93El6pPiqNlRMeta?.path ?? "/complete-registration/:uuid()",
    meta: _91uuid_93El6pPiqNlRMeta || {},
    alias: _91uuid_93El6pPiqNlRMeta?.alias || [],
    redirect: _91uuid_93El6pPiqNlRMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/complete-registration/[uuid].vue").then(m => m.default || m)
  },
  {
    name: _91unique_id_93wicVIUpbNsMeta?.name ?? "contracts-unique_id",
    path: _91unique_id_93wicVIUpbNsMeta?.path ?? "/contracts/:unique_id()",
    meta: _91unique_id_93wicVIUpbNsMeta || {},
    alias: _91unique_id_93wicVIUpbNsMeta?.alias || [],
    redirect: _91unique_id_93wicVIUpbNsMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/contracts/[unique_id].vue").then(m => m.default || m)
  },
  {
    name: dashboardLUjLdkoyjDMeta?.name ?? "dashboard",
    path: dashboardLUjLdkoyjDMeta?.path ?? "/dashboard",
    meta: dashboardLUjLdkoyjDMeta || {},
    alias: dashboardLUjLdkoyjDMeta?.alias || [],
    redirect: dashboardLUjLdkoyjDMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/dashboard.vue").then(m => m.default || m)
  },
  {
    name: indexkFsYmcRuaZMeta?.name ?? "event-details-event_id",
    path: indexkFsYmcRuaZMeta?.path ?? "/event/details/:event_id()",
    meta: indexkFsYmcRuaZMeta || {},
    alias: indexkFsYmcRuaZMeta?.alias || [],
    redirect: indexkFsYmcRuaZMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/event/details/[event_id]/index.vue").then(m => m.default || m)
  },
  {
    name: checkout5Wmj6mnW2AMeta?.name ?? "event-details-event_id-product-product_id-checkout",
    path: checkout5Wmj6mnW2AMeta?.path ?? "/event/details/:event_id()/product/:product_id()/checkout",
    meta: checkout5Wmj6mnW2AMeta || {},
    alias: checkout5Wmj6mnW2AMeta?.alias || [],
    redirect: checkout5Wmj6mnW2AMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue").then(m => m.default || m)
  },
  {
    name: select_45productDLAHgz5yD4Meta?.name ?? "event-details-event_id-select-product",
    path: select_45productDLAHgz5yD4Meta?.path ?? "/event/details/:event_id()/select-product",
    meta: select_45productDLAHgz5yD4Meta || {},
    alias: select_45productDLAHgz5yD4Meta?.alias || [],
    redirect: select_45productDLAHgz5yD4Meta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/event/details/[event_id]/select-product.vue").then(m => m.default || m)
  },
  {
    name: eventsY1i6h5kOHpMeta?.name ?? "events",
    path: eventsY1i6h5kOHpMeta?.path ?? "/events",
    meta: eventsY1i6h5kOHpMeta || {},
    alias: eventsY1i6h5kOHpMeta?.alias || [],
    redirect: eventsY1i6h5kOHpMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/events.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93Zp3gW4XxebMeta?.name ?? "gifts-uuid",
    path: _91uuid_93Zp3gW4XxebMeta?.path ?? "/gifts/:uuid()",
    meta: _91uuid_93Zp3gW4XxebMeta || {},
    alias: _91uuid_93Zp3gW4XxebMeta?.alias || [],
    redirect: _91uuid_93Zp3gW4XxebMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/gifts/[uuid].vue").then(m => m.default || m)
  },
  {
    name: index6WKGl0cWmuMeta?.name ?? "gifts",
    path: index6WKGl0cWmuMeta?.path ?? "/gifts",
    meta: index6WKGl0cWmuMeta || {},
    alias: index6WKGl0cWmuMeta?.alias || [],
    redirect: index6WKGl0cWmuMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/gifts/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_id_93FrEKbfqFEIMeta?.name ?? "gifts-invitation-invitation_id",
    path: _91invitation_id_93FrEKbfqFEIMeta?.path ?? "/gifts/invitation/:invitation_id()",
    meta: _91invitation_id_93FrEKbfqFEIMeta || {},
    alias: _91invitation_id_93FrEKbfqFEIMeta?.alias || [],
    redirect: _91invitation_id_93FrEKbfqFEIMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/gifts/invitation/[invitation_id].vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93hFAsXHEIOmMeta?.name ?? "gifts-product-product_id",
    path: _91product_id_93hFAsXHEIOmMeta?.path ?? "/gifts/product/:product_id()",
    meta: _91product_id_93hFAsXHEIOmMeta || {},
    alias: _91product_id_93hFAsXHEIOmMeta?.alias || [],
    redirect: _91product_id_93hFAsXHEIOmMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/gifts/product/[product_id].vue").then(m => m.default || m)
  },
  {
    name: indexjxOEpBK09sMeta?.name ?? "index",
    path: indexjxOEpBK09sMeta?.path ?? "/",
    meta: indexjxOEpBK09sMeta || {},
    alias: indexjxOEpBK09sMeta?.alias || [],
    redirect: indexjxOEpBK09sMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_unique_id_93AeADjrSpWSMeta?.name ?? "invitation-invitation_unique_id",
    path: _91invitation_unique_id_93AeADjrSpWSMeta?.path ?? "/invitation/:invitation_unique_id()",
    meta: _91invitation_unique_id_93AeADjrSpWSMeta || {},
    alias: _91invitation_unique_id_93AeADjrSpWSMeta?.alias || [],
    redirect: _91invitation_unique_id_93AeADjrSpWSMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/invitation/[invitation_unique_id].vue").then(m => m.default || m)
  },
  {
    name: joinBUVMujuZjeMeta?.name ?? "join",
    path: joinBUVMujuZjeMeta?.path ?? "/join",
    meta: joinBUVMujuZjeMeta || {},
    alias: joinBUVMujuZjeMeta?.alias || [],
    redirect: joinBUVMujuZjeMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/join.vue").then(m => m.default || m)
  },
  {
    name: loginzlsnftm6NmMeta?.name ?? "login",
    path: loginzlsnftm6NmMeta?.path ?? "/login",
    meta: loginzlsnftm6NmMeta || {},
    alias: loginzlsnftm6NmMeta?.alias || [],
    redirect: loginzlsnftm6NmMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/login.vue").then(m => m.default || m)
  },
  {
    name: logouth7sKfXAxE9Meta?.name ?? "logout",
    path: logouth7sKfXAxE9Meta?.path ?? "/logout",
    meta: logouth7sKfXAxE9Meta || {},
    alias: logouth7sKfXAxE9Meta?.alias || [],
    redirect: logouth7sKfXAxE9Meta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/logout.vue").then(m => m.default || m)
  },
  {
    name: _91meeting_type_slug_93tBDPe9XqHcMeta?.name ?? "meet-meeting_type_slug",
    path: _91meeting_type_slug_93tBDPe9XqHcMeta?.path ?? "/meet/:meeting_type_slug()",
    meta: _91meeting_type_slug_93tBDPe9XqHcMeta || {},
    alias: _91meeting_type_slug_93tBDPe9XqHcMeta?.alias || [],
    redirect: _91meeting_type_slug_93tBDPe9XqHcMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/meet/[meeting_type_slug].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93Rhh6ldbaDfMeta?.name ?? "meet-meeting_unique_id",
    path: _91meeting_unique_id_93Rhh6ldbaDfMeta?.path ?? "/meet/:meeting_unique_id()",
    meta: _91meeting_unique_id_93Rhh6ldbaDfMeta || {},
    alias: _91meeting_unique_id_93Rhh6ldbaDfMeta?.alias || [],
    redirect: _91meeting_unique_id_93Rhh6ldbaDfMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/meet/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93BPFo6SwMWNMeta?.name ?? "meeting-meeting_unique_id",
    path: _91meeting_unique_id_93BPFo6SwMWNMeta?.path ?? "/meeting/:meeting_unique_id()",
    meta: _91meeting_unique_id_93BPFo6SwMWNMeta || {},
    alias: _91meeting_unique_id_93BPFo6SwMWNMeta?.alias || [],
    redirect: _91meeting_unique_id_93BPFo6SwMWNMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/meeting/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: my_45favoritestmIyIzbG48Meta?.name ?? "my-favorites",
    path: my_45favoritestmIyIzbG48Meta?.path ?? "/my-favorites",
    meta: my_45favoritestmIyIzbG48Meta || {},
    alias: my_45favoritestmIyIzbG48Meta?.alias || [],
    redirect: my_45favoritestmIyIzbG48Meta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/my-favorites.vue").then(m => m.default || m)
  },
  {
    name: my_45studiosjrNZ0XMqtPMeta?.name ?? "my-studios",
    path: my_45studiosjrNZ0XMqtPMeta?.path ?? "/my-studios",
    meta: my_45studiosjrNZ0XMqtPMeta || {},
    alias: my_45studiosjrNZ0XMqtPMeta?.alias || [],
    redirect: my_45studiosjrNZ0XMqtPMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/my-studios.vue").then(m => m.default || m)
  },
  {
    name: optinBb1fE315KXMeta?.name ?? "optin",
    path: optinBb1fE315KXMeta?.path ?? "/optin",
    meta: optinBb1fE315KXMeta || {},
    alias: optinBb1fE315KXMeta?.alias || [],
    redirect: optinBb1fE315KXMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/optin.vue").then(m => m.default || m)
  },
  {
    name: _91episode_id_93mMzwUQyVnjMeta?.name ?? "podcasts-podcast_id-episodes-episode_id",
    path: _91episode_id_93mMzwUQyVnjMeta?.path ?? "/podcasts/:podcast_id()/episodes/:episode_id()",
    meta: _91episode_id_93mMzwUQyVnjMeta || {},
    alias: _91episode_id_93mMzwUQyVnjMeta?.alias || [],
    redirect: _91episode_id_93mMzwUQyVnjMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue").then(m => m.default || m)
  },
  {
    name: indexhuyYT1MaumMeta?.name ?? "podcasts-podcast_id",
    path: indexhuyYT1MaumMeta?.path ?? "/podcasts/:podcast_id()",
    meta: indexhuyYT1MaumMeta || {},
    alias: indexhuyYT1MaumMeta?.alias || [],
    redirect: indexhuyYT1MaumMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/podcasts/[podcast_id]/index.vue").then(m => m.default || m)
  },
  {
    name: index4RaFBy7RMqMeta?.name ?? "podcasts",
    path: index4RaFBy7RMqMeta?.path ?? "/podcasts",
    meta: index4RaFBy7RMqMeta || {},
    alias: index4RaFBy7RMqMeta?.alias || [],
    redirect: index4RaFBy7RMqMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/podcasts/index.vue").then(m => m.default || m)
  },
  {
    name: _91product_id_931F4L8exNrXMeta?.name ?? "product-product_id",
    path: _91product_id_931F4L8exNrXMeta?.path ?? "/product/:product_id()",
    meta: _91product_id_931F4L8exNrXMeta || {},
    alias: _91product_id_931F4L8exNrXMeta?.alias || [],
    redirect: _91product_id_931F4L8exNrXMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutI6XisP4OFiMeta?.name ?? "product-product_id-about",
    path: aboutI6XisP4OFiMeta?.path ?? "about",
    meta: aboutI6XisP4OFiMeta || {},
    alias: aboutI6XisP4OFiMeta?.alias || [],
    redirect: aboutI6XisP4OFiMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: digital_45download_45contentdcLnt6TjeWMeta?.name ?? "product-product_id-digital-download-content",
    path: digital_45download_45contentdcLnt6TjeWMeta?.path ?? "digital-download-content",
    meta: digital_45download_45contentdcLnt6TjeWMeta || {},
    alias: digital_45download_45contentdcLnt6TjeWMeta?.alias || [],
    redirect: digital_45download_45contentdcLnt6TjeWMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/digital-download-content.vue").then(m => m.default || m)
  },
  {
    name: eventsVS1iBvUiiPMeta?.name ?? "product-product_id-events",
    path: eventsVS1iBvUiiPMeta?.path ?? "events",
    meta: eventsVS1iBvUiiPMeta || {},
    alias: eventsVS1iBvUiiPMeta?.alias || [],
    redirect: eventsVS1iBvUiiPMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93vfYE4pD4rhMeta?.name ?? "product-product_id-free-media-media_id",
    path: _91media_id_93vfYE4pD4rhMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93vfYE4pD4rhMeta || {},
    alias: _91media_id_93vfYE4pD4rhMeta?.alias || [],
    redirect: _91media_id_93vfYE4pD4rhMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45sampletLGd4EkfS9Meta?.name ?? "product-product_id-free-sample",
    path: free_45sampletLGd4EkfS9Meta?.path ?? "free-sample",
    meta: free_45sampletLGd4EkfS9Meta || {},
    alias: free_45sampletLGd4EkfS9Meta?.alias || [],
    redirect: free_45sampletLGd4EkfS9Meta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45products4u4cAOnabBMeta?.name ?? "product-product_id-included-products",
    path: included_45products4u4cAOnabBMeta?.path ?? "included-products",
    meta: included_45products4u4cAOnabBMeta || {},
    alias: included_45products4u4cAOnabBMeta?.alias || [],
    redirect: included_45products4u4cAOnabBMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93ApbmzoMlQvMeta?.name ?? "product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93ApbmzoMlQvMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93ApbmzoMlQvMeta || {},
    alias: _91media_id_93ApbmzoMlQvMeta?.alias || [],
    redirect: _91media_id_93ApbmzoMlQvMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewmxufo7A6QvMeta?.name ?? "product-product_id-lessons-lesson_id-view",
    path: viewmxufo7A6QvMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewmxufo7A6QvMeta || {},
    alias: viewmxufo7A6QvMeta?.alias || [],
    redirect: viewmxufo7A6QvMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexI8rYlFusBWMeta?.name ?? "product-product_id-lessons",
    path: indexI8rYlFusBWMeta?.path ?? "lessons",
    meta: indexI8rYlFusBWMeta || {},
    alias: indexI8rYlFusBWMeta?.alias || [],
    redirect: indexI8rYlFusBWMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93KyToUu84K6Meta?.name ?? "product-product_id-media-media_id",
    path: _91media_id_93KyToUu84K6Meta?.path ?? "media/:media_id()",
    meta: _91media_id_93KyToUu84K6Meta || {},
    alias: _91media_id_93KyToUu84K6Meta?.alias || [],
    redirect: _91media_id_93KyToUu84K6Meta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexNRHHo68UqTMeta?.name ?? "product-product_id-playlists-playlist_id",
    path: indexNRHHo68UqTMeta?.path ?? "playlists/:playlist_id()",
    meta: indexNRHHo68UqTMeta || {},
    alias: indexNRHHo68UqTMeta?.alias || [],
    redirect: indexNRHHo68UqTMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_938UbZMMKcpVMeta?.name ?? "product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_938UbZMMKcpVMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_938UbZMMKcpVMeta || {},
    alias: _91media_id_938UbZMMKcpVMeta?.alias || [],
    redirect: _91media_id_938UbZMMKcpVMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexPEZjWP3NWEMeta?.name ?? "product-product_id-playlists",
    path: indexPEZjWP3NWEMeta?.path ?? "playlists",
    meta: indexPEZjWP3NWEMeta || {},
    alias: indexPEZjWP3NWEMeta?.alias || [],
    redirect: indexPEZjWP3NWEMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsQMffEmjoZlMeta?.name ?? "product-product_id-private-sessions",
    path: private_45sessionsQMffEmjoZlMeta?.path ?? "private-sessions",
    meta: private_45sessionsQMffEmjoZlMeta || {},
    alias: private_45sessionsQMffEmjoZlMeta?.alias || [],
    redirect: private_45sessionsQMffEmjoZlMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsITyKxOmkTrMeta?.name ?? "product-product_id-recordings",
    path: recordingsITyKxOmkTrMeta?.path ?? "recordings",
    meta: recordingsITyKxOmkTrMeta || {},
    alias: recordingsITyKxOmkTrMeta?.alias || [],
    redirect: recordingsITyKxOmkTrMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviews4sUMKF9StpMeta?.name ?? "product-product_id-reviews",
    path: reviews4sUMKF9StpMeta?.path ?? "reviews",
    meta: reviews4sUMKF9StpMeta || {},
    alias: reviews4sUMKF9StpMeta?.alias || [],
    redirect: reviews4sUMKF9StpMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexVZie5H9FXiMeta?.name ?? "product",
    path: indexVZie5H9FXiMeta?.path ?? "/product",
    meta: indexVZie5H9FXiMeta || {},
    alias: indexVZie5H9FXiMeta?.alias || [],
    redirect: indexVZie5H9FXiMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/product/index.vue").then(m => m.default || m)
  },
  {
    name: indexp5TuKKtYMLMeta?.name ?? "profile",
    path: indexp5TuKKtYMLMeta?.path ?? "/profile",
    meta: indexp5TuKKtYMLMeta || {},
    alias: indexp5TuKKtYMLMeta?.alias || [],
    redirect: indexp5TuKKtYMLMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/profile/index.vue").then(m => m.default || m)
  },
  {
    name: purchasesAfAf88UDK3Meta?.name ?? "profile-purchases",
    path: purchasesAfAf88UDK3Meta?.path ?? "/profile/purchases",
    meta: purchasesAfAf88UDK3Meta || {},
    alias: purchasesAfAf88UDK3Meta?.alias || [],
    redirect: purchasesAfAf88UDK3Meta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/profile/purchases.vue").then(m => m.default || m)
  },
  {
    name: redemptionsgHHNODBJgpMeta?.name ?? "profile-redemptions",
    path: redemptionsgHHNODBJgpMeta?.path ?? "/profile/redemptions",
    meta: redemptionsgHHNODBJgpMeta || {},
    alias: redemptionsgHHNODBJgpMeta?.alias || [],
    redirect: redemptionsgHHNODBJgpMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/profile/redemptions.vue").then(m => m.default || m)
  },
  {
    name: _91quiz_id_93IRUQzwM6XvMeta?.name ?? "quiz-quiz_id",
    path: _91quiz_id_93IRUQzwM6XvMeta?.path ?? "/quiz/:quiz_id()",
    meta: _91quiz_id_93IRUQzwM6XvMeta || {},
    alias: _91quiz_id_93IRUQzwM6XvMeta?.alias || [],
    redirect: _91quiz_id_93IRUQzwM6XvMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/quiz/[quiz_id].vue").then(m => m.default || m)
  },
  {
    name: _91token_93oZ1mkcip05Meta?.name ?? "reset-password-uid-token",
    path: _91token_93oZ1mkcip05Meta?.path ?? "/reset-password/:uid()/:token()",
    meta: _91token_93oZ1mkcip05Meta || {},
    alias: _91token_93oZ1mkcip05Meta?.alias || [],
    redirect: _91token_93oZ1mkcip05Meta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/reset-password/[uid]/[token].vue").then(m => m.default || m)
  },
  {
    name: resetpAPPIalodPMeta?.name ?? "reset",
    path: resetpAPPIalodPMeta?.path ?? "/reset",
    meta: resetpAPPIalodPMeta || {},
    alias: resetpAPPIalodPMeta?.alias || [],
    redirect: resetpAPPIalodPMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/reset.vue").then(m => m.default || m)
  },
  {
    name: shopo6tTwHz7SyMeta?.name ?? "shop",
    path: shopo6tTwHz7SyMeta?.path ?? "/shop",
    meta: shopo6tTwHz7SyMeta || {},
    alias: shopo6tTwHz7SyMeta?.alias || [],
    redirect: shopo6tTwHz7SyMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/shop.vue").then(m => m.default || m)
  },
  {
    name: signupHnVTwDActzMeta?.name ?? "signup",
    path: signupHnVTwDActzMeta?.path ?? "/signup",
    meta: signupHnVTwDActzMeta || {},
    alias: signupHnVTwDActzMeta?.alias || [],
    redirect: signupHnVTwDActzMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/signup.vue").then(m => m.default || m)
  },
  {
    name: liveXJTn2yIAyvMeta?.name ?? "streaming-event_id-live",
    path: liveXJTn2yIAyvMeta?.path ?? "/streaming/:event_id()/live",
    meta: liveXJTn2yIAyvMeta || {},
    alias: liveXJTn2yIAyvMeta?.alias || [],
    redirect: liveXJTn2yIAyvMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/streaming/[event_id]/live.vue").then(m => m.default || m)
  },
  {
    name: tipsNjFE8hgoFMMeta?.name ?? "tips",
    path: tipsNjFE8hgoFMMeta?.path ?? "/tips",
    meta: tipsNjFE8hgoFMMeta || {},
    alias: tipsNjFE8hgoFMMeta?.alias || [],
    redirect: tipsNjFE8hgoFMMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/tips.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93kCzCzYnYqRMeta?.name ?? "waiver-uuid",
    path: _91uuid_93kCzCzYnYqRMeta?.path ?? "/waiver/:uuid()",
    meta: _91uuid_93kCzCzYnYqRMeta || {},
    alias: _91uuid_93kCzCzYnYqRMeta?.alias || [],
    redirect: _91uuid_93kCzCzYnYqRMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/waiver/[uuid].vue").then(m => m.default || m)
  },
  {
    name: compactkXQTjQ4JlFMeta?.name ?? "widgets-calendars-compact",
    path: compactkXQTjQ4JlFMeta?.path ?? "/widgets/calendars/compact",
    meta: compactkXQTjQ4JlFMeta || {},
    alias: compactkXQTjQ4JlFMeta?.alias || [],
    redirect: compactkXQTjQ4JlFMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/widgets/calendars/compact.vue").then(m => m.default || m)
  },
  {
    name: full14Wqs82i8DMeta?.name ?? "widgets-calendars-full",
    path: full14Wqs82i8DMeta?.path ?? "/widgets/calendars/full",
    meta: full14Wqs82i8DMeta || {},
    alias: full14Wqs82i8DMeta?.alias || [],
    redirect: full14Wqs82i8DMeta?.redirect,
    component: () => import("/tmp/build_8a9f1a71/pages/[studio_url]/widgets/calendars/full.vue").then(m => m.default || m)
  }
]